<template>
  <div  >
		 
  </div>
</template>

<script>
	import $TN from "./tn_code.min.js";
	 
	
	export default $TN
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 @import './style.css';
</style>
